import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  sideBar: false,
  profileData:false
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    // setAnswerValue: (state, actions: PayloadAction<ISetAnswerValue>) => {
    //   state.answerSubmitValue = actions.payload.data
    // },
    setsideBar: (state) => {
      state.sideBar = !state.sideBar;
    },
    setProfileData: (state) => {
      state.profileData = !state.profileData;
    },
  },
});

export const dashboardAction = dashboardSlice.actions;
export const dashboardReducer = dashboardSlice.reducer;
